import { css } from '@adornis/chemistry/directives/css.js';
import { XDialog } from '@adornis/dialog/x-dialog.js';
import type { FormController } from '@adornis/forms/x-form-controller.js';
import type { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import type { Student } from '@chancenwerk/master-data-management/users/entities/Student.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AnmeldungRoutes } from '../routes.js';
import { AnmeldungPageRegistrationBase } from './anmeldung-component-formular-base.js';

/**
 * @customElement anmeldung-component-formular-data-overview
 */
@customElement('anmeldung-component-formular-data-overview')
export class AnmeldungPageRegistrationLangSelect extends AnmeldungPageRegistrationBase {
  @property({ attribute: false }) form!: FormController<Student>;
  @property({ attribute: false }) translation!: TranslationController<any>;
  @property({ attribute: 'school-level' }) schoolLevel: 'us' | 'os' = 'us';

  override render() {
    if (this.schoolLevel === 'us')
      return html`
        <cr-flex class="section-container" space="xl">
          <cr-flex class="sc-content">
            <cr-flex space="xl">
              <cr-h4 align="center">
                <b> Einwilligungs&shy;erklärungen </b>
              </cr-h4>
              <cr-text>
                Über den folgenden Link haben Sie die Möglichkeit, weitere Informationen zur Aufsichts- und
                Schweigepflicht, Kündigung und zur Verwendung von Foto- und Videoaufnahmen durchzulesen.
              </cr-text>
              <cr-link target="_blank" href=${AnmeldungRoutes.registerDeclaration} ${css({ alignSelf: 'center' })}>
                <cr-text> Informationen zur Mitgliedschaft </cr-text>
              </cr-link>
              <cr-text>
                Diese Informationen übersenden wir Ihnen auch im Nachgang in der Bestätigungsmail und zudem per Post, da
                wir zu den genannten Bereichen noch Unterschriften für die vollständige Anmeldung benötigen.
              </cr-text>

              <cr-text>
                Nachdem Sie Ihre Daten überprüft haben, übermitteln Sie uns mit Klick auf "Absenden" die Anmeldung für
                Ihr Kind. Sie erhalten eine Bestätigungsmail mit allen wesentlichen Informationen zu den nächsten
                Schritten. Bitte lesen Sie diese aufmerksam durch.
              </cr-text>

              <cr-button
                @click=${async () => {
                  await XDialog.waitFor(this.form.validate());
                }}
              >
                ${this.translation.translate('confirm')}
              </cr-button>
            </cr-flex>
          </cr-flex>
        </cr-flex>
      `;
    return html`
      <cr-flex class="section-container" space="xl">
        <cr-flex class="sc-content">
          <cr-flex space="xl">
            <cr-h4 align="center">
              <b> Fast geschafft... </b>
            </cr-h4>
            <cr-text>
              Du erhältst gleich einen Infobrief von uns, den du mit nach Hause nimmst und bitte deinen
              Erziehungsberechtigten gibst.
            </cr-text>
            <cr-text>
              Deine Erziehungsberechtigten erhalten in einigen Tagen wichtige Unterlagen per Post an die angegebene
              Adresse. Lest diese Unterlagen bitte gemeinsam durch und füllt sie aus. Bitte sendet die Unterlagen
              ausgefüllt und unterschrieben mit dem Rücksendeumschlag an uns zurück.
            </cr-text>
            <cr-text>
              Wir senden dir eine E-Mail zu, wenn die ersten Workshops starten und bevor die Lernförderung beginnt.
            </cr-text>
            <cr-text ${css({ textAlign: 'center' })} bold>
              Wir freuen uns auf deine Teilnahme an der CHANCENreise!
            </cr-text>

            <cr-button
              @click=${async () => {
                await XDialog.waitFor(this.form.validate());
              }}
            >
              ${this.translation.translate('confirm')}
            </cr-button>
          </cr-flex>
        </cr-flex>
      </cr-flex>
    `;
  }
}
